/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useCallback } from 'react';
import type {
  SetTruckShareTargetRequest,
  TruckShareOverviewDTO,
} from '.././model';
import { useCustomInstance } from '.././mutator/custom-instance';

export const useInternalDeliveryTruckShareGetTruckShareOverviewHook = () => {
  const internalDeliveryTruckShareGetTruckShareOverview =
    useCustomInstance<TruckShareOverviewDTO>();

  return useCallback(
    (signal?: AbortSignal) => {
      return internalDeliveryTruckShareGetTruckShareOverview({
        url: `/api/InternalDeliveryTruckShare/GetTruckShareOverview`,
        method: 'GET',
        signal,
      });
    },
    [internalDeliveryTruckShareGetTruckShareOverview]
  );
};

export const getInternalDeliveryTruckShareGetTruckShareOverviewQueryKey =
  () => {
    return [`/api/InternalDeliveryTruckShare/GetTruckShareOverview`] as const;
  };

export const useInternalDeliveryTruckShareGetTruckShareOverviewQueryOptions = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useInternalDeliveryTruckShareGetTruckShareOverviewHook>
    >
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useInternalDeliveryTruckShareGetTruckShareOverviewHook
        >
      >
    >,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getInternalDeliveryTruckShareGetTruckShareOverviewQueryKey();

  const internalDeliveryTruckShareGetTruckShareOverview =
    useInternalDeliveryTruckShareGetTruckShareOverviewHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useInternalDeliveryTruckShareGetTruckShareOverviewHook
        >
      >
    >
  > = ({ signal }) => internalDeliveryTruckShareGetTruckShareOverview(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useInternalDeliveryTruckShareGetTruckShareOverviewHook
        >
      >
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type InternalDeliveryTruckShareGetTruckShareOverviewQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useInternalDeliveryTruckShareGetTruckShareOverviewHook
        >
      >
    >
  >;
export type InternalDeliveryTruckShareGetTruckShareOverviewQueryError = unknown;

export const useInternalDeliveryTruckShareGetTruckShareOverview = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useInternalDeliveryTruckShareGetTruckShareOverviewHook>
    >
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useInternalDeliveryTruckShareGetTruckShareOverviewHook
        >
      >
    >,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useInternalDeliveryTruckShareGetTruckShareOverviewQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useInternalDeliveryTruckShareSetTruckShareTargetHook = () => {
  const internalDeliveryTruckShareSetTruckShareTarget =
    useCustomInstance<Blob>();

  return useCallback(
    (setTruckShareTargetRequest: SetTruckShareTargetRequest) => {
      return internalDeliveryTruckShareSetTruckShareTarget({
        url: `/api/InternalDeliveryTruckShare/SetTruckShareTarget`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: setTruckShareTargetRequest,
        responseType: 'blob',
      });
    },
    [internalDeliveryTruckShareSetTruckShareTarget]
  );
};

export const useInternalDeliveryTruckShareSetTruckShareTargetMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useInternalDeliveryTruckShareSetTruckShareTargetHook>
      >
    >,
    TError,
    { data: SetTruckShareTargetRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<
      ReturnType<typeof useInternalDeliveryTruckShareSetTruckShareTargetHook>
    >
  >,
  TError,
  { data: SetTruckShareTargetRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const internalDeliveryTruckShareSetTruckShareTarget =
    useInternalDeliveryTruckShareSetTruckShareTargetHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useInternalDeliveryTruckShareSetTruckShareTargetHook>
      >
    >,
    { data: SetTruckShareTargetRequest }
  > = (props) => {
    const { data } = props ?? {};

    return internalDeliveryTruckShareSetTruckShareTarget(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type InternalDeliveryTruckShareSetTruckShareTargetMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<typeof useInternalDeliveryTruckShareSetTruckShareTargetHook>
      >
    >
  >;
export type InternalDeliveryTruckShareSetTruckShareTargetMutationBody =
  SetTruckShareTargetRequest;
export type InternalDeliveryTruckShareSetTruckShareTargetMutationError =
  unknown;

export const useInternalDeliveryTruckShareSetTruckShareTarget = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useInternalDeliveryTruckShareSetTruckShareTargetHook>
      >
    >,
    TError,
    { data: SetTruckShareTargetRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<
      ReturnType<typeof useInternalDeliveryTruckShareSetTruckShareTargetHook>
    >
  >,
  TError,
  { data: SetTruckShareTargetRequest },
  TContext
> => {
  const mutationOptions =
    useInternalDeliveryTruckShareSetTruckShareTargetMutationOptions(options);

  return useMutation(mutationOptions);
};
